// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3TQPl","text":"SelectPayment_text__zFdDS","title":"SelectPayment_title__2d3F8","btn":"SelectPayment_btn__2bObM"};